export function propertiesToJss({ color }) {
  
  let jss = {}

  if(color) {
    jss['color'] = color        
  }

  return jss
}